export default __webpack_public_path__ + "static/media/up-blue.46d618fb.svg";